export const getPercent = (number, numberFrom) =>
	(number / numberFrom) * 100 || 0;
